import React, { Component } from 'react';
import { Image, Col, Row, Container } from 'react-bootstrap';
import HtmlModal from './htmlModal';
import termsHTML from './htmls/termsContent.js';
import privacyHTML from './htmls/privacyContent.js';
import Logo from '../../../img/newLogo.png';
import Facebook from '../../../img/footer/Facebook.svg';
import Insta from '../../../img/footer/Insta.svg';
import Linkedin from '../../../img/footer/Linkedin.svg';
import PciImage from '../../../img/footer/pci-dss.png'
import VisaLogo from '../../../img/visa_logo.png';
import MasterLogo from '../../../img/mastercard_logo.png';
import Translate from '../../../../../translate';
import Arrow from '../../../img/iconos/blue-arrow.svg';
import './index.css';

class Unete extends Component {
  constructor(props){
    super(props);
    this.state = {
      showPrivacy:this.props.showPrivacy,
      showTerms:this.props.showTerms
    }
  }

  render() {
    return (
      <div className='footer-background section-container'>
        <Container>
          <Row>
            <Col md={4}>
              <Row>
                <Image src={Logo} className='footer-logo'/>
              </Row>
              <Row>
                <Image src={Facebook} className='footer-img' onClick={()=>window.open('https://www.facebook.com/wirebitdigital','_blank')}/>
                <Image src={Insta} className='footer-img' onClick={()=>window.open('https://www.instagram.com/wirebitdigital/','_blank')}/>
                <Image src={Linkedin} className='footer-img' onClick={()=>window.open('https://www.linkedin.com/company/wirebit-oficial/mycompany','_blank')}/>
              </Row>
            </Col>
            <Col md={8}>
              <Row>
                <Col md={6}>
                  <p className='footer-title'>{Translate[this.props.lan].landing3.footer.contactanos}</p>
                  <p className='footer-text'>{Translate[this.props.lan].landing3.footer.texto1} <br/> hello@wirebit.com</p>
                  <p className='footer-text'>{Translate[this.props.lan].landing3.footer.texto2} <br/>{Translate[this.props.lan].landing3.footer.texto3}</p>
                </Col>
                <Col md={6}>
                  <p className='footer-title'>{Translate[this.props.lan].landing3.footer.acerca}</p>
                  <p className='footer-link' onClick={()=>this.setState({showPrivacy:true})}>{Translate[this.props.lan].landing3.footer.privacidad} <Image style={{marginLeft: '5px'}} src={Arrow} width={18}/></p>
                  <p className='footer-link' onClick={()=>this.setState({showTerms:true})}>{Translate[this.props.lan].landing3.footer.terminosCondiciones} <Image style={{marginLeft: '5px'}} src={Arrow} width={18}/></p>
                  {/* <div style={{display:'flex',flexDirection:'row', alignItems:'center'}}>
                    <div>
                      <Image src={VisaLogo} className='card-img-footer' />
                    </div>
                    <div>
                      <Image src={MasterLogo} className='card-img-footer' />
                    </div>
                  </div> */}
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
        <HtmlModal
          show={this.state.showPrivacy}
          close={()=>this.setState({showPrivacy:false})}
          html={privacyHTML}
        />
        <HtmlModal
          show={this.state.showTerms}
          close={()=>this.setState({showTerms:false})}
          html={termsHTML}
          />
      </div>
    );
  }
}

export default Unete
